export const TITLE = 'Title';
export const INSTRUCTIONS = 'Instructions';

export const RESET = 'RESET';
